import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { UserData, User } from '../data/users';
import { MessageHandlerService } from "../../services/message-handler.service"
import { EventEmitter } from '@angular/core';

@Injectable()
export class UserService extends UserData {

  emitter: EventEmitter<any> = new EventEmitter();
  api: string;
  loggedUser: User;
  apiForm: string;
  header: any;
  constructor(private http: HttpClient, private messageHandler: MessageHandlerService) {
    super();
    this.api = environment.apiUrl;
  }


  subscribeToUpdate() {
    return this.emitter;
  }

  updateListeners() {
    this.emitter.emit("");
  }

  async signUp(user: User) {
    try {

      let response = await this.http.post(this.api + "signUp", user).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async getFlyers(language: string) {
    try {
      let flyers = await this.http.get(this.api + "flyer/" + language, { responseType: 'arraybuffer' }).toPromise();
      return flyers
    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async getPromotions() {
    try {
      let flyers = await this.http.get(this.api + "promotions").toPromise();
      return flyers
    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async invoices() {
    try {
      let invoices = await this.http.get(this.api + "invoices").toPromise();
      return invoices
    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async deleteUser(id?) {
    try {
      let flyers = await this.http.delete(this.api + "user/" + (id || "")).toPromise();
      return flyers
    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async getCurrentUser() {
    try {
      let user = await this.http.get(this.api + "user").toPromise();
      this.loggedUser = <User>user;

      return user
    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async getLoggedUser() {

    if (!this.loggedUser) {
      let user = await this.http.get(this.api + "user").toPromise();
      this.loggedUser = <User>user;
    }
    return this.loggedUser
  }


  async updateLoggedUser() {

    let user = await this.http.get(this.api + "user").toPromise();
    this.loggedUser = <User>user;
    return this.loggedUser
  }

  async createUser(data) {
    try {

      let response = await this.http.post(this.api + "user", data).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async getUsers(pagination, filter, order) {
    try {
      let response = await this.http.post(this.api + "users", { pagination, filter, order }).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async getUser(id: string) {
    try {

      let user = <User>await this.http.get(this.api + "user/" + id).toPromise();
      return user

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async editUser(data, id?: string) {
    try {

      let response = <User>await this.http.put(this.api + "user/" + (id || ''), data).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }


  async redeemCoupon(data) {
    try {

      let response = await this.http.post(this.api + "coupon", { code: data }).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }


}
